import { FC, Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button, Card, Grid } from '@mui/material';
//components
import DataLoader from 'components/common/DataLoader';
import InputController from 'controller/InputController';
import PhoneInputController from 'controller/PhoneInputController';
//constants, interfaces, helper, interface, styles
import {
  SAVE_TEXT,
  PHONE_TEXT,
  EMAIL_TEXT,
  PASSWORD_TEXT,
  LAST_NAME_TEXT,
  FIRST_NAME_TEXT,
  GENERATE_PASSWORD_TEXT,
  ORGANIZATION_NAME_TEXT,
  MAX_STAFF,
} from 'constants/index';
import { generateRandomPassword } from 'lib/helper';
import { AddNewUserFormType, UserCardProps } from 'interfaces';
import { forInputLabelBg, overflowVisible } from 'styles/commonComponentStyle';

const UserCard: FC<UserCardProps> = ({ loading, isEdit = false }): JSX.Element => {
  const { setValue } = useFormContext<AddNewUserFormType>();

  const generatePassword = () => {
    const password = generateRandomPassword();
    setValue('password', password);
  };

  return (
    <Card sx={[forInputLabelBg, overflowVisible]}>
      {loading ? (
        <DataLoader columns={12} rows={isEdit ? 4 : 5} />
      ) : (
        <Fragment>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <InputController
                isRequired
                fieldType="text"
                name="organizationName"
                title={ORGANIZATION_NAME_TEXT}
              />
            </Grid>

            <Grid item xs={12} lg={6}>
              <InputController
                isRequired
                name="firstName"
                fieldType="text"
                disabled={loading}
                title={FIRST_NAME_TEXT}
              />
            </Grid>

            <Grid item xs={12} lg={6}>
              <InputController
                isRequired
                name="lastName"
                fieldType="text"
                disabled={loading}
                title={LAST_NAME_TEXT}
              />
            </Grid>

            <Grid item xs={12} lg={12}>
              <InputController
                isRequired
                name="email"
                fieldType="text"
                title={EMAIL_TEXT}
                disabled={loading}
              />
            </Grid>

            <Grid item xs={12} lg={12}>
              <PhoneInputController name="phone" title={PHONE_TEXT} />
            </Grid>

            <Grid item xs={12} lg={12}>
              <InputController name="maxUser" isRequired fieldType="number" title={MAX_STAFF} />
            </Grid>

            {!isEdit ? (
              <>
                <Grid item xs={12} lg={7}>
                  <InputController
                    name="password"
                    title={PASSWORD_TEXT}
                    fieldType="password"
                    isPassword
                    isRequired
                  />
                </Grid>

                <Grid item xs={12} lg={5}>
                  <Button variant="contained" fullWidth sx={{ height: 56 }} onClick={generatePassword}>
                    {GENERATE_PASSWORD_TEXT}
                  </Button>
                </Grid>
              </>
            ) : (
              <Grid item xs={12} lg={12} justifyContent="flex-end" display="flex">
                <Button type="submit" variant="contained" size="small" disabled={loading}>
                  {SAVE_TEXT}
                </Button>
              </Grid>
            )}
          </Grid>
        </Fragment>
      )}
    </Card>
  );
};

export default UserCard;
